'use client';

import type { ReactElement } from 'react';
import { LibraryBigIcon, PieChartIcon } from 'lucide-react';
import Link from 'next/link';
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from '@/components/ui/navigation-menu';
import { useScopedI18n } from '@/locales/client';

export default function Navigation(): ReactElement {
  const t = useScopedI18n('header');

  return (
    <nav className="w-fit flex items-center justify-center gap-2 sm:gap-4 md:gap-8">
      <NavigationMenu>
        <NavigationMenuList className="lg:hidden">
          <NavigationMenuItem>
            <NavigationMenuTrigger className="bg-transparent">Menu</NavigationMenuTrigger>
            <NavigationMenuContent>
              <ul className="w-[160px] gap-3 p-4 flex flex-col">
                <li>
                  <NavigationMenuLink asChild>
                    <Link
                      href={'/about'}
                      className="w-fit flex items-center justify-center gap-1 opacity-85 transition-all hover:opacity-100"
                    >
                      <LibraryBigIcon className="w-4 sm:w-5" />
                      <p className="text-sm sm:text-base font-light">{t('about')}</p>
                    </Link>
                  </NavigationMenuLink>
                </li>
                <li>
                  <NavigationMenuLink asChild>
                    <Link
                      href={'/tokenomics'}
                      className="w-fit flex items-center justify-center gap-1 opacity-85 transition-all hover:opacity-100"
                    >
                      <PieChartIcon className="w-4 sm:w-5" />
                      <p className="text-sm sm:text-base font-light">{t('tokenomics')}</p>
                    </Link>
                  </NavigationMenuLink>
                </li>
              </ul>
            </NavigationMenuContent>
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>
      <Link
        href={'/about'}
        className="w-fit items-center justify-center gap-1 opacity-85 hover:opacity-100 hidden lg:flex"
      >
        <LibraryBigIcon className="w-4 sm:w-5" />
        <p className="text-sm md:text-base font-light">{t('about')}</p>
      </Link>
      <Link
        href={'/tokenomics'}
        className="w-fit items-center justify-center gap-1 opacity-85 hover:opacity-100 hidden lg:flex"
      >
        <PieChartIcon className="w-4 sm:w-5" />
        <p className="text-sm md:text-base font-light">{t('tokenomics')}</p>
      </Link>
    </nav>
  );
}
